import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useApiClient } from './useApiClient';
import { ApiIloqBookingSchema } from '@allbin/viu-api-client';
import { useIdentity } from '../providers/IdentityProvider';
import { useCallback } from 'react';
import useConfig from './useConfig';

interface UseResourceSchemaOptions {
  resourceId: string;
}

export function useResourceSchema({
  resourceId,
}: UseResourceSchemaOptions): UseQueryResult<ApiIloqBookingSchema> {
  const config = useConfig();
  const apiClient = useApiClient();
  const { id: deviceId } = useIdentity(
    useCallback((state: { id?: string }) => ({ id: state.id }), []),
  );

  return useQuery({
    queryKey: ['resourceSchema', deviceId, resourceId, config.bookingSystem],
    queryFn: async (): Promise<ApiIloqBookingSchema> => {
      if (!deviceId) {
        console.warn('[useResourceSchema] deviceId missing, skipping fetch.');
        throw new Error('deviceId missing');
      }
      if (config.bookingSystem !== 'iloq') {
        console.warn(
          '[useResourceSchema] Booking system is not iloq, skipping fetch.',
        );
        throw new Error('Booking system is not iloq');
      }
      try {
        const schema = await apiClient.public.devices.getIloqResourceSchema(
          deviceId,
          resourceId,
        );
        return schema;
      } catch (error) {
        console.error(
          `[useResourceSchema] Failed to fetch schema for resource ${resourceId}:`,
          error,
        );
        throw error;
      }
    },
    enabled: !!deviceId && !!resourceId,
    staleTime: 24 * 60 * 60 * 1000,
  });
}
